export default __webpack_public_path__ + "static/media/interessado.7b2f7768.jpg";